import { createHeadlessCookiesBanner, DEFAULT_CONSENT_COOKIE_NAME } from "cookies-eu-banner/headless"

document.addEventListener("turbolinks:load", function() {
    const banner = document.getElementById("cookies-eu-banner")
    if (!banner) return

    const cookiesBanner = createHeadlessCookiesBanner({
        onShowBanner: function() {
            banner.style.display = "block"
            // Continuing to browse counts as consent, so the banner is only shown once
            cookiesBanner.setCookie(DEFAULT_CONSENT_COOKIE_NAME, "true")

            document.getElementById("cookies-eu-accept").addEventListener("click", function() {
                cookiesBanner.setConsent(true)
            })
            // Visitors reading the privacy policy get asked again
            document.getElementById("cookies-eu-more").addEventListener("click", function() {
                cookiesBanner.deleteCookie(DEFAULT_CONSENT_COOKIE_NAME)
            })
        },
        onAccept: function() {
            banner.remove()
            // Code to launch when user accept cookies
            console.log("Cookies Consent accepted")
        },
        onReject: function() {
            banner.remove()
        },
    })

    cookiesBanner.checkConsentAndShowBanner()
});
